// filepath: /Users/thomasgaggl/Softline/development/nx/libs/framework/core/src/lib/date/functions/manupulation/start-of/start-of-quater.function.ts
import { isIsoDate } from '../../validation/is-iso-date.function';
import { isIsoDateTime } from '../../validation/is-iso-date-time.function';
import { isIsoDateTimeTz } from '../../validation/is-iso-date-time-tz.function';
import { getTimeOffset } from '../../get/get-time-offset.function';
import { IsoDate, IsoDateTime, IsoDateTimeTz } from '../../../types/iso-date';
import { deconstructDate } from '../../helper/deconstruct-date.function';
import { getLastMonthOfQuarter } from '../../helper/last-month-of-quarter';
import { getLastDayOfMonth } from '../../helper/last-day-of-month.function';
import { constructDate } from '../../helper/construct-date.function';
import { getFirstMonthOfQuarter } from '../../helper/first-month-of-quarter.function';


/**
 * Returns the first day/instant of the quarter for a given ISO input.
 * - For date-only (YYYY-MM-DD) -> returns 'YYYY-MM-01' with MM = 01|04|07|10
 * - For date-time without tz -> returns 'YYYY-MM-01T00:00:00.000'
 * - For date-time with tz -> returns 'YYYY-MM-01T00:00:00.000Z|±HH:MM'
 */
export function startOfQuarter<T extends IsoDate | IsoDateTime | IsoDateTimeTz>(input: T): T {
  const deconstructed = deconstructDate(input);
  if (deconstructed._type !== 'date' && deconstructed._type !== 'dateTime' && deconstructed._type !== 'dateTimeTz') {
    throw new Error('startOfQuarter: invalid ISO date/time string');
  }
  deconstructed.month = getFirstMonthOfQuarter(deconstructed.month);
  deconstructed.day = 1;
  if (deconstructed._type !== 'date') {
    deconstructed.hours = 0;
    deconstructed.minutes = 0;
    deconstructed.seconds = 0;
    deconstructed.milliseconds = 0;
  }
  return constructDate(deconstructed) as unknown as T;
}
